import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Instagram, Twitter, Facebook, Heart } from "lucide-react";
import { api } from "../lib/api";

const PlatformIcon = ({ platform }) => {
    const cls = "w-4 h-4";
    if (platform === "twitter") return <Twitter className={cls} />;
    if (platform === "facebook") return <Facebook className={cls} />;
    return <Instagram className={cls} />;
};

export default function SocialFeed({ limit = 6, columns = 3, slug = null }) {
    const { data: posts = [], isLoading } = useQuery({
        queryKey: ["social"],
        queryFn: async () => (await api.get("/social")).data,
    });

    if (isLoading) return <div className="text-zinc-500">Loading social wall…</div>;

    const filtered = slug ? posts.filter((p) => p.product_slug === slug) : posts;
    const items = filtered.slice(0, limit);
    const colCls = columns === 4 ? "md:grid-cols-4" : columns === 2 ? "md:grid-cols-2" : "md:grid-cols-3";

    return (
        <div className={`grid sm:grid-cols-2 ${colCls} gap-4`} data-testid="social-feed">
            {items.map((p) => (
                <article key={p.id} className="p-5 rounded-sm bg-bg1 border border-white/10 hover:border-lime/40 transition-colors" data-testid={`social-post-${p.handle.replace('@','')}`}>
                    <div className="flex items-center gap-3 mb-3">
                        <img src={p.avatar} alt={p.handle} className="w-10 h-10 rounded-full object-cover ring-1 ring-white/10" />
                        <div className="flex-1 min-w-0">
                            <div className="text-sm font-semibold truncate">{p.handle}</div>
                            <div className="text-[10px] uppercase tracking-widest text-zinc-500 flex items-center gap-1.5">
                                <PlatformIcon platform={p.platform} /> {p.platform}
                            </div>
                        </div>
                    </div>
                    <p className="text-zinc-300 text-sm leading-relaxed">{p.content}</p>
                    <div className="mt-4 pt-3 border-t border-white/5 flex items-center justify-between text-xs">
                        <div className="text-zinc-500 uppercase tracking-widest">{p.product_slug.replace('-', ' ')}</div>
                        <div className="inline-flex items-center gap-1.5 text-zinc-400">
                            <Heart className="w-3.5 h-3.5 text-red-400" /> {p.likes}
                        </div>
                    </div>
                </article>
            ))}
        </div>
    );
}
